import React from 'react';

const Guide = () => {
	return (
		<div className="flex flex-wrap gap-2">
			<div className="flex items-center space-x-1">
				<div className="w-4 h-4 border-2 border-neutral-400 dark:border-neutral-400 rounded-md"></div>
				<div className="text-sm text-neutral-700 dark:text-neutral-200">Starpvērtējums</div>
			</div>
			<div className="flex items-center space-x-1">
				<div className="w-4 h-4 border-2  border-neutral-500 dark:border-neutral-200 rounded-md"></div>
				<div className="text-sm text-neutral-700 dark:text-neutral-200">Gala vērtējums</div>
			</div>
		</div>
	);
};

export default Guide;